import React, { useEffect, useState } from "react";
import {
  examtitlelist,
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stusubjectlist,
} from "../../../services/master";
import moment from "moment/moment";
import Select from "react-select";
import {
  academylist,
  examstudentcreate,
  examstudentdetail,
} from "../../../services/admin";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function Createexamsubject() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [adate, setADate] = useState("");
  const [atime, setATime] = useState("");

  const [etitle, setETitle] = useState("");
  const [tlist, setTList] = useState([]);

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [studiv, setStuDiv] = useState("");
  const [dlist, setDList] = useState([]);

  const [stusub, setStuSub] = useState("");
  const [slist, setSList] = useState([]);

  const [tmark, setTMark] = useState("");
  const [pmark, setPMark] = useState("");
  const[pass,setPass]=useState("")
  const location = useLocation();
  const [urllink, setUrllink] = useState("");

  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrllink(path);
    

   

    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setDList(arr);
        }
      }
    });
   

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });

    if (path === "createexamsubject") {
      setADate(moment(new Date()).format("YYYY-MM-DD"));
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                  listall(arr[0]);
                  setAYear(localStorage.getItem("AYear"));
                }
              }
             
            }
          }
        });
      }
    } else {
      examstudentdetail(id).then((res) => {
        if (res.status === true && res.data) {
          setAYear(res.data.academy_year);
          setADate(moment(res.data.exam_date).format("YYYY-MM-DD"));
          setATime(res.data.exam_time);
          setETitle(res.data.exam_type);
          setStuCls(res.data.class_id);
          setStuDiv(res.data.section);
          setStuSub(res.data.subject_id);
          setTMark(res.data.theory_mark);
          if (res.data.pratical_mark !== null) {
            setPMark(res.data.pratical_mark);
          }
          if(res.data.pass_marks !== null){
            setPass(res.data.pass_marks)
          }
          if (localStorage.getItem("Role") === "1") {
            academylist().then((res1) => {
              if (res.status === true) {
                let arr = [];
                if (res1.data.details.length > 0) {
                  for (let i = 0; i < res1.data.details.length; i++) {
                    if (res1.data.details[i].id === res.data.academy_id) {
                      arr.push({
                        value: res1.data.details[i].id,
                        label:
                          res1.data.details[i].name +
                          " - " +
                          res1.data.details[i].code,
                      });
                    }
                  }
                  setAcaID(arr[0]);
                }
              }
            });
          }


          
        }
      });
    }
    listall("");

  }, []);
  const [examerr, setExamerr] = useState(false);
  const [errormsg, setErrMsg] = useState("");

  function subexam(e) {
    e.preventDefault();
    setExamerr(true);
    let valid = "";

    if (
      ayear !== "" &&
      etitle !== "" &&
      adate !== "" &&
      // atime !== "" &&
      stucls !== "" &&
      studiv !== "" &&
      stusub !== "" &&
      tmark !== "" &&
      pass !== ""
    ) {
      if (localStorage.getItem("Role") === "1") {
        if (acaid === "") {
          valid = "Please Select Academy";
          setErrMsg("Please Select Academy");
        }
      }

      var sec = "";
      if (studiv.length !== 0) {
        if (studiv.length === 1) {
          sec = studiv[0].value;
        } else {
          var values = [];
          for (var i = 0; i < studiv.length; i++) {
            values.push(studiv[i].value);
          }
          sec = values.join(",");
        }
      }

      if (valid === "") {
        setLoading(true);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("exam_type", etitle);
        temp.append("exam_date", adate);
        temp.append("exam_time", atime);
        temp.append("academy_year", ayear);
        temp.append("class_id", stucls);
        temp.append("theory_mark", tmark);
        temp.append("pratical_mark", pmark);
        temp.append("pass_marks", pass);
        temp.append("subject_id", stusub);

        if (urllink === "examsubjectdetail") {
          temp.append("id", id);
          temp.append("section", studiv);
        }else{
          temp.append("section", sec);

        }
        examstudentcreate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            setExamerr(false);
            toast.success(res.message);
            navigate("/exam/listallexams");
          } else {
            setLoading(false);
            setExamerr(false);
            setErrMsg(res.data.join(","));
          }
        });
      }
    }
  }

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }

  function listall(aid){
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });


    examtitlelist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].exam_title,
            });
          }
          setTList(arr);
        }
      }
    });

    stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        // let arr = [];
        // if (res.data.length > 0) {
        //   for (let i = 0; i < res.data.length; i++) {
        //     arr.push({
        //       value: res.data[i].id,
        //       label: res.data[i].subject_name,
        //     });
        //   }

          setSList(res.data);
        }
      // }
    });
  }

  function handleSection(e) {
    if (e !== null) {
      setStuDiv(e);
    } else {
      setStuDiv("");
    }
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          {urllink === "createexamsubject" ? "Create Exam" : "Exam Detail"}
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Exam Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "createexamsubject" ? "Create Exam" : "Exam Detail"}
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card mb-4">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  {urllink === "createexamsubject"
                    ? "Create Exam"
                    : "Exam Detail"}
                </h2>
              </div>
              <div className="card-body">
                <div className="row">
                  {localStorage.getItem("Role") === "1" && (
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                        {examerr && acaid === "" && (
                          <span className="text-danger">
                            Please Select Academy
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Academic Year<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select form-control wide"
                        onChange={(e) => setAYear(e.target.value)}
                        value={ayear}
                      >
                        <option value="" disabled>
                          Select Academic Year
                        </option>
                        {alist.map((item) => (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {examerr && ayear === "" && (
                        <span className="text-danger">
                          Please Select Academic Year
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Exam Title<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select form-control wide"
                        onChange={(e) => setETitle(e.target.value)}
                        value={etitle}
                      >
                        <option value="" disabled>
                          Select Exam Title
                        </option>
                        {tlist.map((item) => (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {examerr && etitle === "" && (
                        <span className="text-danger">
                          Please Select Exam Title
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Exam Date<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => setADate(e.target.value)}
                        value={adate}
                      />
                      {examerr && adate === "" && (
                        <span className="text-danger">
                          Please Select Exam Date
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Exam Time
                        <span className="text-danger">
                          {" "}
                           (FN/AN)
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Exam Time"
                        onChange={(e) => setATime(e.target.value)}
                        value={atime}
                      />
                      {/* {examerr && atime === "" && (
                        <span className="text-danger">
                          Please Select Exam Time
                        </span>
                      )} */}
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Select Class<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select form-control wide"
                        onChange={(e) => setStuCls(e.target.value)}
                        value={stucls}
                      >
                        <option value="" disabled>
                          Select Class
                        </option>
                        {clist.map((item) => (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {examerr && stucls === "" && (
                        <span className="text-danger">Please Select Class</span>
                      )}
                    </div>
                  </div>
                  {urllink !== "examsubjectdetail" && (
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Select Section<span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Section"
                          value={studiv}
                          options={dlist}
                          onChange={handleSection}
                          isSearchable={true}
                          isMulti
                          isClearable
                          hidden
                        />
                        {examerr && studiv === "" && (
                          <span className="text-danger">
                            Please Select Section
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {urllink === "examsubjectdetail" && (
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Select Section<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => setStuDiv(e.target.value)}
                          value={studiv}
                        >
                          <option value="" disabled>
                            Select Section
                          </option>
                          {dlist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                        {examerr && studiv === "" && (
                          <span className="text-danger">
                            Please Select Section
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Select Exam Subjects
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select form-control wide"
                        value={stusub}
                        onChange={(e) => setStuSub(e.target.value)}
                      >
                        <option value="" disabled>
                          Select Exam Subjects
                        </option>
                        {slist.map((item) => (
                          <option value={item.id} key={item.value}>
                            {item.subject_name}
                          </option>
                        ))}
                      </select>
                      {examerr && stusub === "" && (
                        <span className="text-danger">
                          Please Select Exam Subjects
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Theory Mark Out Off
                        <span className="text-danger"> * (Eg: 100)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Theory Mark Out Off"
                        onChange={(e) => setTMark(e.target.value)}
                        value={tmark}
                      />
                      {examerr && tmark === "" && (
                        <span className="text-danger">
                          Please Enter Theory Mark Out Off
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Practical Mark Out Off
                        <span className="text-danger"> (Eg: 100)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Practical Mark Out Off"
                        onChange={(e) => setPMark(e.target.value)}
                        value={pmark}
                      />
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-6">
                      <label className="form-label">
                        Pass Mark
                        <span className="text-danger"> * (Eg: 100)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Pass Mark"
                        onChange={(e) => setPass(e.target.value)}
                        value={pass}
                      />
                      {examerr && pass === "" && (
                        <span className="text-danger">
                          Please Enter Pass Mark
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {errormsg && <span className="text-danger">{errormsg}</span>}

                <div className="res-right me-4 mt-1">
                  <button className="btn btn-success me-2" onClick={subexam}>
                    {urllink === "examsubjectdetail" ? "Update" : "Submit"}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate("/exam/listallexams")}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
